import React, { Component } from 'react';
import axios from 'axios';

import './Mariachi.css';
import FullDirectory from '../Directory/FullDirectory/FullDirectory';
import Info from '../Tools/Info';
import Directors from '../Tools/Directors';
import Carousel from '../Tools/Carousel';

import { FILE } from '../../utils/constants/pdf';

export default class Mariachi extends Component {
  state = {
    info: false,
    directory: false,
    directors: [],
    department: 'Mariachi',
    contest: [
      // { title: '2021/2022 Mariachi Contest', href: FILE.mariachiSchedule },
    ],
    files: [
      // { title: 'Solo & Ensemble Entering Instructions', href: FILE.allSoloEntrance },
      // { title: 'Concert & SightReading Entering Instructions', href: FILE.allContestEntrance },
      { title: 'Letter of Intent', href: FILE.intentLetter },
      {
        title: 'TMEA Directors Handbook',
        href:
          'https://www.dropbox.com/sh/nv9p91mlymr088z/AAALmzZCdLQ9gQGvZszNDj3ja?dl=0&preview=2018-2019+TMEA+REGION+20+MARIACHI+DIRECTORS+HANDBOOK.pdf',
      },
      { title: 'TMEA Student Handbook', href: FILE.studentHandbook },
      { title: 'TMEA Directors Handbook', href: FILE.mariachiHandbook },
      { title: 'Mariachi Rubric', href: FILE.mariachiForm4 },
      { title: 'Mariachi Form 4', href: FILE.mariachiForm4 },
    ],
    imageList: [
      {
        img:
          'https://res.cloudinary.com/dwvrok1le/image/upload/v1547230453/mariachi.jpg',
        school: 'W.E. Greiner Exploratory Arts Academy',
      },
    ],
    infoLinks: [
      'Registration Deadline: October 8, 2022',
      'Registration Fees: $20/ Student ($50 Campus Fee)',
      'Audition Date: October 22, 2022 @ 9am (HS ALL-STATE CERTIFICATION AUDITIONS)',
      'Audition Location: W.E. GREINER MS - 501 S. Edgefield Ave. Dallas, TX 75208',
      'Region HS/MS Ensembles: 1 HS Region Ensemble/ 1 MS Region Ensemble',
      'Instrumentation: (25) 12 Vlns/ 3 Tpts/ 2 Harps/ 2 Gtrn/ 2 Vih/ 2 Gtr/ 2 Golpes/ 2 Flutes ',
      'All State Instrumentation: 9 Vlns./ 3 Tpts./ 1 Harp/ 1 Gtrn./ 1 Vih./ 2 Gtr./ 1 Golpe ',
      'Region 20 HS All-State Recording: (Oct. 29th) BOOKER T. WASHINGTON HS',
      'Region Sectionals Date: Monday, December 5, 2022 (6-9pm) @ Booker T. Washington HS',
      'Region Clinic: Friday, December 9th  & 10th  @ Booker T. Washington HS',
      'Region Concert: Saturday, December 10th, 2022 3-4pm @ Booker T. Washington HS',
    ]
  };

  componentDidMount() {
    this.getContacts();
  }

  getContacts() {
    const mar = 'Mariachi';
    axios.get(`/api/contacts?department=${mar}`).then((res) => {
      this.setState({ directors: res.data });
    });
  }

  toggleClick = (a, b) => {
    this.setState({
      info: a,
      directory: b,
    });
  };

  render() {
    const { info, directory, directors, files, contest, infoLinks } = this.state;
    return (
      <div className="band_main">
        <div className="component_img" />
        <div className="band_content">
          <div className="band_header">
            <div className="band_header_container">
              <div className="band_sub_nav">
                <h1
                  className="band_link a"
                  onClick={() => this.toggleClick(false, false)}
                >
                  Mariachi
                </h1>
                <h2
                  className="band_link a bl-1"
                  onClick={() => this.toggleClick(true, false)}
                >
                  Information
                </h2>
                {/* <h2
                  className="band_link a bl-1"
                  onClick={() => this.toggleClick(false, true)}
                >
                  Directory
                </h2> */}
              </div>
            </div>
          </div>

          <div className="band_header_small">
            <div className="band_header_container">
              <div className="band_sub_nav">
                <h1
                  className="band_link a big-link"
                  onClick={() => this.toggleClick(false, false)}
                >
                  Mariachi
                </h1>
                <h2
                  className="band_link a side-link"
                  onClick={() => this.toggleClick(true, false)}
                >
                  Information
                </h2>
                <h2
                  className="band_link a side-link"
                  onClick={() => this.toggleClick(false, true)}
                >
                  Directory
                </h2>
              </div>
            </div>
          </div>
          {!info && !directory && (
            <div className="band_home scroll">
              <h2>Our Directors</h2>
              <div className="map_holder">
                <Directors directors={[]} />
              </div>
            </div>
          )}
          {info && (
            <div className="band_high scroll">
              <Carousel imageList={this.state.imageList} />
              <div>
                <Info
                  contest={contest}
                  files={files}
                  title="Mariachi Director Information"
                />
                <div style={{
                  maxWidth: '750px',
                  margin: 'auto'
                }}>
                  <h3>Mariachi Info</h3>
                  <ul>
                    {infoLinks.map((info, infoIndex) => (
                      <li key={infoIndex}>
                        {info}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}
          {directory && (
            <div className="band_middle scroll">
              <h2 className="band_title">Directory</h2>
              <FullDirectory department={this.state.department} />
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Mariachi/Mariachi.js